export class GridTile {
  // Global static property for blank character
  static blankChar = " ";

  constructor(solution, row, column) {
    if (typeof row !== "number" || isNaN(row) || row < 0) {
      throw new Error(
        "GridTile constructor: 'row' must be a positive integer."
      );
    }
    if (typeof column !== "number" || isNaN(column) || column < 0) {
      throw new Error(
        "GridTile constructor: 'column' must be a positive integer."
      );
    }
    this.solution = solution;
    this.playing = GridTile.blankChar;
    this.peeking = GridTile.blankChar;
    this.scratch = GridTile.blankChar;

    this.row = row;
    this.col = column;

    this.acrossGridWord = null;
    this.downGridWord = null;
  }

  getAcrossWord() {
    return this.acrossGridWord;
  }
  getDownWord() {
    return this.downGridWord;
  }

  // Getters
  getSolutionValue() {
    return this.solution;
  }
  getPlayingValue() {
    return this.playing;
  }
  getPeekingValue() {
    return this.peeking;
  }
  getScratchValue() {
    return this.scratch;
  }
  // Setters
  setPlayingValue(value) {
    this.playing = value;
  }
  setPeekingValue(value) {
    this.peeking = value;
  }
  setScratchValue(value) {
    this.scratch = value;
  }
  setAcrossGridWord(word) {
    this.acrossGridWord = word;
  }
  setDownGridWord(word) {
    this.downGridWord = word;
  }
  getGridLocation() {
    return { row: this.row, col: this.col };
  }

  /**
   * Returns the zero-based index of this tile within the given grid word.
   * @param {object} gridWord - The grid word object containing this tile.
   * @returns {number|null} The index within the word, or null if not found.
   */
  getIndexInWord(gridWord) {
    if (!gridWord || !Array.isArray(gridWord.tiles)) {
      return null;
    }
    return gridWord.tiles.indexOf(this);
  }

  /**
   * Sets the guess character for this tile and propagates it to the parent grid word
   * based on the current orientation ('across' or 'down').
   * @param {string} char - The guessed character.
   */
  setGuessChar(char) {
    this.setPlayingValue(char);
    if (
      this.acrossGridWord &&
      typeof this.acrossGridWord.setGuessChar === "function"
    ) {
      const indexOfTile = this.getIndexInWord(this.acrossGridWord);
      this.acrossGridWord.setGuessChar(indexOfTile, char);
    }
    if (
      this.downGridWord &&
      typeof this.downGridWord.setGuessChar === "function"
    ) {
      const indexOfTile = this.getIndexInWord(this.downGridWord);
      this.downGridWord.setGuessChar(indexOfTile, char);
    }
  }

  removeGuessChar() {
    this.setPlayingValue(GridTile.blankChar);
    if (
      this.acrossGridWord &&
      typeof this.acrossGridWord.removeGuessChar === "function"
    ) {
      const indexOfTile = this.getIndexInWord(this.acrossGridWord);
      this.acrossGridWord.removeGuessChar(indexOfTile);
    }
    if (
      this.downGridWord &&
      typeof this.downGridWord.removeGuessChar === "function"
    ) {
      const indexOfTile = this.getIndexInWord(this.downGridWord);
      this.downGridWord.removeGuessChar(indexOfTile);
    }
  }

  /**
   * Sets the revealed character for this tile and propagates it to the parent grid word
   * based on the current orientation ('across' or 'down').
   * @param {string} character - The guessed character.
   */
  setRevealedChar(character) {
    if (this.getSolutionValue() != this.getPlayingValue()) {
      this.setPlayingValue(character);
      this.setPeekingValue(character);
    }

    if (
      this.acrossGridWord &&
      typeof this.acrossGridWord.setGuessChar === "function"
    ) {
      const indexOfTile = this.getIndexInWord(this.acrossGridWord);
      this.acrossGridWord.setGuessChar(indexOfTile, character);
    }
    if (
      this.downGridWord &&
      typeof this.downGridWord.setGuessChar === "function"
    ) {
      const indexOfTile = this.getIndexInWord(this.downGridWord);
      this.downGridWord.setGuessChar(indexOfTile, character);
    }
  }
}

export const BLANK_CHAR = GridTile.blankChar;
